import React, { Component } from 'react';
import { SelectionStyle, SelectionType } from '@philips-internal/oswald-ui-constants';
import { classNames, isEnumValid, isFunction, noop } from '@philips-internal/oswald-ui-utils';
import { Checkbox } from '../../checkbox/checkbox.js';
import { CollapseArrow } from '../../collapse-arrow/collapse-arrow.js';
import { HeadingContext } from '../../heading/components/heading-context/heading-context.js';
import { RadioButton } from '../../radio-group/radio-button.js';
import { DeckGroupBackgroundColor } from '../deck-constants.js';
import './deck-group.css';
class DeckGroup extends Component {
    constructor() {
        super(...arguments);
        this.popCustomClassName = noop;
        this.state = {
            collapsed: false,
        };
        this.onHeaderClick = () => {
            const { onSelect, selected } = this.props;
            if (isFunction(onSelect)) {
                onSelect(!selected);
            }
        };
        this.onSelectionChange = ({ value }) => {
            const { onSelect } = this.props;
            if (isFunction(onSelect)) {
                onSelect(value);
            }
        };
        this.onCollapseArrowClick = (event) => {
            const { collapsible } = this.props;
            if (!collapsible) {
                return;
            }
            event.stopPropagation();
            this.setState((prevState) => ({ collapsed: !prevState.collapsed }));
        };
    }
    componentDidMount() {
        const { initialCollapsed } = this.props;
        if (this.context) {
            this.popCustomClassName = this.context.pushCustomClassName('c-deck-group__contextual-bar');
        }
        this.setState({ collapsed: initialCollapsed });
    }
    componentWillUnmount() {
        this.popCustomClassName();
    }
    renderCheckbox() {
        const { context, groupKey, selected, selectable, selectionType } = this.props;
        if (!selectable || !context.allowMultipleGroupsSelection(selectionType)) {
            return null;
        }
        return (React.createElement(Checkbox, { className: "c-deck-group__checkbox", name: groupKey, onChange: this.onSelectionChange, uuid: "deck-group-checkbox-uuid", value: selected }));
    }
    renderRadioGroup() {
        const { groupKey, selected, selectable, selectionStyle, selectionType } = this.props;
        if (!selectable || selectionType !== SelectionType.SINGLE_GROUP || selectionStyle !== SelectionStyle.RADIO) {
            return null;
        }
        return (React.createElement(RadioButton, { checked: selected, className: "c-deck-group__radio-button", label: "", name: groupKey, onChange: this.onSelectionChange, uuid: "deck-group-radio-button-uuid", value: "" }));
    }
    renderCollapseArrow() {
        const { collapsible } = this.props;
        const { collapsed } = this.state;
        if (!collapsible) {
            return null;
        }
        return (React.createElement(CollapseArrow, { className: "c-deck-group__collapse-arrow", collapsed: collapsed, onClick: this.onCollapseArrowClick }));
    }
    getWrapperClassNames() {
        const { selected } = this.props;
        return classNames({
            'c-deck-group__wrapper': true,
            'c-deck-group__wrapper-selected': selected,
        });
    }
    getHeaderClassNames() {
        const { groupBackgroundColor } = this.props;
        return classNames({
            'c-deck-group__header': true,
            [`c-deck-group__header--${groupBackgroundColor}`]: isEnumValid(DeckGroupBackgroundColor, groupBackgroundColor),
        });
    }
    getContentStyle() {
        const { groupContentMargin, groupContentPadding } = this.props;
        return {
            margin: groupContentMargin,
            padding: groupContentPadding,
        };
    }
    render() {
        const { children, renderHeaderContent } = this.props;
        const { collapsed } = this.state;
        return (React.createElement("div", { className: this.getWrapperClassNames() },
            React.createElement("div", { className: this.getHeaderClassNames(), onClick: this.onCollapseArrowClick },
                React.createElement("div", { className: "c-deck-group__content", onClick: this.onHeaderClick }, renderHeaderContent()),
                React.createElement("div", { className: "c-deck-group__header-actions" },
                    this.renderCollapseArrow(),
                    this.renderCheckbox(),
                    this.renderRadioGroup())),
            !collapsed ? (React.createElement("div", { style: this.getContentStyle() }, children)) : null));
    }
}
DeckGroup.contextType = HeadingContext;
export { DeckGroup, };
//# sourceMappingURL=deck-group.js.map